import styled from "styled-components";

export const Input = styled.input`
  width: 100%;
  height: 3.5rem;
  outline: 0;
  border: 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray500};
  border-radius: 0.5rem 0.5rem 0 0;
  padding-left: 0.5rem;
  padding-top: 1.75rem;
  padding-bottom: 0.5rem;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.5rem;
  background: ${({ theme }) => theme.colors.gray100};

  &:focus-within + label, &:valid:not(:placeholder-shown) + label, &:disabled + label {
      transform: translate(0, -0.375rem) scale(1);
      font-size: 0.9rem;
      font-weight: 400;
      
    }

  &:focus-within {
    color: ${({ theme }) => theme.colors.blue400};
    border-bottom: 1px solid ${({ theme }) => theme.colors.blue400};
  }

  &:valid:not(:placeholder-shown):valid:not(:focus) {
    background: ${({ theme }) => theme.colors.white};
  }

  &:disabled {
    color: ${({theme}) => theme.colors.gray400};
    border-bottom: 0.07rem solid ${({theme}) => theme.colors.gray400};
    cursor: not-allowed;
  }

  &:disabled + label {
    color: ${({theme}) => theme.colors.gray400};
  }

  &::placeholder {
    color: transparent;
  }

  ${({hasError, theme}) => (hasError ? `
    background: ${theme.colors.red100},
    color: ${theme.colors.red300},
    borderBottom: 0.07rem solid ${theme.colors.red300},

    &:focus: {
      borderBottom: 0.07rem solid ${theme.colors.red300},
      color: ${theme.colors.red300},
    },
`:``)}

  ${({variant}) => (variant === "select" ? `
    padding: 0.8rem 0.5rem 0 4.6rem;

    &:focus-within + label, &:valid:not(:placeholder-shown) + label, &:disabled + label {
      transform: translate(-2.9rem, 0.3rem) scale(0.75);
      font-size: 0.8rem;
      font-weight: 400;
    }
  `: ``)}

`